// Nouvelles adresses (domeinApp.nl.ts). Version française.
export const appDomeinFr = {
    company: {
        title: 'Informations sur l’entreprise',
        kvk: 'Chambre de commerce (KvK) {kvk}',
        contact: 'Contact',
        where: 'L’app se trouve sur {app} et le tableau au mur sur {board}. Connecte-toi uniquement sur {app}.',
    },
    /** Oude beginscherm-app van f.amumin.com: weg, en {app} opnieuw op het beginscherm. */
    homeScreen: 'AMUMIN était sur ton écran d’accueil ? Supprime l’ancienne icône et remets {app} sur l’écran d’accueil. Sur iPhone ou iPad, les notifications ne marchent que depuis l’écran d’accueil.',
    push: {
        title: 'Les notifications sont désactivées dans ce navigateur',
        body: 'AMUMIN se trouve maintenant sur amumin.app. Les notifications s’activent par adresse, ce navigateur doit donc le refaire une fois. Veux-tu de nouveau recevoir des notifications ici ?',
        action: 'Activer les notifications',
        later: 'Pas maintenant',
        done: 'Les notifications sont de nouveau activées.',
        denied: 'Ce navigateur bloque les notifications. Tu peux les autoriser dans les réglages du navigateur.',
    },
};
//# sourceMappingURL=domeinApp.fr.js.map